import { Snackbar, Alert, AlertTitle } from '@mui/material';
import { formatMessage } from 'src/i18n/intl';
import Locale from 'src/i18n';

const FailedToUpdateUserAlert = ({ handleUpdateUserFailed }) => {
    return (
        <Snackbar
            open
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            autoHideDuration={5000}
            disableWindowBlurListener
            onClose={handleUpdateUserFailed}>
            <div>
                <Alert
                    severity="error"
                    contrast="normal"
                    width="toast"
                    onClose={handleUpdateUserFailed}
                    title={formatMessage(Locale.success)}>
                    <AlertTitle>{formatMessage(Locale.error)}</AlertTitle>
                    {formatMessage(Locale.bulkImportUpdateUserFailed)}
                </Alert>
            </div>
        </Snackbar>
    );
};

export default FailedToUpdateUserAlert;
